export function NoVenuesIllustration() {
  return (
    <svg
      width="200"
      height="160"
      viewBox="0 0 200 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Building outline */}
      <path
        d="M60 140 L60 60 L100 40 L140 60 L140 140 Z"
        fill="#F3F4F6"
        stroke="#D1D5DB"
        strokeWidth="2"
      />

      {/* Roof */}
      <path d="M50 60 L100 35 L150 60 Z" fill="#E5E7EB" stroke="#D1D5DB" strokeWidth="2" />

      {/* Windows */}
      <rect x="70" y="75" width="15" height="15" rx="2" fill="white" stroke="#D1D5DB" />
      <rect x="115" y="75" width="15" height="15" rx="2" fill="white" stroke="#D1D5DB" />
      <rect x="70" y="100" width="15" height="15" rx="2" fill="white" stroke="#D1D5DB" />
      <rect x="115" y="100" width="15" height="15" rx="2" fill="white" stroke="#D1D5DB" />

      {/* Door */}
      <rect x="92.5" y="115" width="15" height="25" rx="2" fill="white" stroke="#D1D5DB" />
      <circle cx="103" cy="127.5" r="1.5" fill="#9CA3AF" />

      {/* Search cross overlay */}
      <circle cx="100" cy="100" r="25" fill="white" fillOpacity="0.9" />
      <path d="M85 100 L115 100 M100 85 L100 115" stroke="#D1D5DB" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
